module.exports = __webpack_public_path__ + "img/product-banxue-js-01.5276bf23.png";